/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
import React from 'react';
import { Button, Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import { useEffectOnce } from '@hooks';
import { popupCenter } from '../../utils';

import classes from './index.module.css';

function OnboardingConnect() {
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '' });

  // useEffectOnce(() => {
  //   const channel = new BroadcastChannel(process.env.BROADCART_CHANNEL_NAME);
  //   channel.onmessage = (e) => {
  //     console.log(e);
  //     window.location.reload();
  //   };
  // }, []);

  const clickHandler = () => {
    popupCenter({
      url: '/connect-store', title: 'connect store', w: 800, h: 600,
    });
  };

  return (
    <div className={classes.content}>
      <div className={classes.circle_background} />
      <div className={classes.greeting}>
        <div className={classes.greeting_primary}>
          Welcome to Seel
        </div>
        <div className={classes.greeting_secondary}>
          We are glad you&#39;re here.
        </div>
      </div>
      <div className={classes.connect}>
        <div className={classes.connect_primary}>Connect your store</div>
        <div className={classes.connect_secondary}>
          {'Welcome! Let\'s start by connecting your Shopify store by clicking the button below.'}
        </div>
        <Button
          style={{ textTransform: 'none' }}
          sx={{
            width: '430PX',
            height: '48PX',
            borderRadius: 0,
            backgroundColor: '#645AFF',
            color: 'white',
            '&:hover': {
              backgroundColor: '#5950DF',
            },
          }}
          onClick={clickHandler}
        >
          Connect your store
        </Button>
      </div>
      <Snackbar
        sx={{
          '& .MuiPaper-root.MuiSnackbarContent-root': {
            backgroundColor: '#D82C0D',
          },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!((snackbar.open && snackbar.message))}
        autoHideDuration={20000}
        message={snackbar.message || 'welcome to seel'}
        onClose={() => setSnackbar({ open: false, message: '' })}
        action={(
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{ p: 0.5 }}
            onClick={() => setSnackbar({ open: false, message: '' })}
          >
            <CloseIcon />
          </IconButton>
        )}
      />
    </div>
  );
}

export default OnboardingConnect;
